import React from "react";
import { LoLang } from "maven-lib/dist/consts";
import { useLangContext } from "@layouts/home/LangContext";
import { classNames } from "maven-lib/dist/utils/misc";
import "./fontController.scss";

interface FontControllerProps {
  lang: LoLang;
}

function readableFontController(lang: LoLang) {
  switch (lang) {
    case LoLang.KO:
      return "가";
    default:
      return "A";
  }
}

export function FontController(props: FontControllerProps) {
  const { lang } = props;
  const { fontSize, setFontSize } = useLangContext();

  return (
    <div className="component-controller-wrapper">
      <div className="component-controller-button-group">
        <button
          type="button"
          className={classNames({ "--left": true, "--selected": fontSize === "SMALL" })}
          onClick={() => setFontSize("SMALL")}
        >
          <span>{readableFontController(lang)}</span>
        </button>
        <button
          type="button"
          className={classNames({ "--middle": true, "--selected": fontSize === "MEDIUM" })}
          onClick={() => setFontSize("MEDIUM")}
        >
          <span>{readableFontController(lang)}</span>
        </button>
        <button
          type="button"
          className={classNames({ "--right": true, "--selected": fontSize === "LARGE" })}
          onClick={() => setFontSize("LARGE")}
        >
          <span>{readableFontController(lang)}</span>
        </button>
      </div>
    </div>
  );
}
